import { Component, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { DashboardModel, DashboardModelDefaultValues } from 'src/app/components/dashboard/dashboard-model';
import { AccessControl, AccessControlDefaultValues } from 'src/app/components/users/access-control';
import { ApplicationRoles } from 'src/app/components/users/user-roles';
import { AuthService } from 'src/app/services/auth.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { UserService } from 'src/app/services/user.service';
import { ParticipantExtractrComponent } from '../../components/reporting/participant-extractr/participant-extractr.component';
import { CourseExtractComponent } from '../../components/reporting/course-extract/course-extract.component';


@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent implements OnInit {

	dashboardModel: DashboardModel = DashboardModelDefaultValues();
	usertype!: ApplicationRoles
	selectedTab: number = 0;
	rolename: string = ''
	accessControl: AccessControl = AccessControlDefaultValues();
	pageName = CheckPageAccess.DASHBOARDADMIN



	constructor(private _authservice: AuthService, private route: ActivatedRoute, private _userservice: UserService, private router: Router,
		private _dashboardService: DashboardService,private dialog:MatDialog) { }

	ngOnInit(): void {
		this._dashboardService.getDashboardContent().subscribe({
			next: (data) => {
				this.dashboardModel = {
					...DashboardModelDefaultValues(),
					...data,
					analytics: {
						...DashboardModelDefaultValues().analytics,
						...(data.analytics ?? {})
					}
				};
			}
		})
	}

	openparticipantreportmodal() {
		const dialogRef = this.dialog.open(ParticipantExtractrComponent,
			{width:'700px'

			}
		)
	}


	opencoursereportmodal() {
		const dialogRef = this.dialog.open(CourseExtractComponent,
			{width:'700px'
				
			}
		)
	}

}
